/* =============================================================================
   Skeleton — Scroll reveal / entrance motion
   Auto-targets sections, headers and cards; staggers siblings; no-op when the
   user prefers reduced motion or IntersectionObserver is unavailable.
   Hidden state is only applied once JS is active (html.js-reveal) so content
   never gets stuck invisible if the script fails to load.
   ============================================================================= */
(function () {
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var root = document.documentElement;

  // Sections that opt in explicitly use [data-reveal]; snippets/product-grid.liquid
  // stamps it on every grid item, so the per-section grid selectors this list used
  // to carry (.collection__grid > li, .main-collection …) are no longer needed.
  var SELECTORS = [
    '[data-reveal]',
    '.pc-panel__header',
    '.featured-collection__header',
    '.discount-offer__header',
    '.collection__header',
    '.section-footer .footer__top',
    '.section-footer .footer__bottom'
  ].join(',');

  var io;

  function init() {
    /* Nodes already handled by an earlier pass are skipped, so a rescan after
       injected markup (see the `on:reveal:scan` listener below) neither
       re-measures settled content nor stacks a second observer on it. */
    var nodes = Array.prototype.slice
      .call(document.querySelectorAll(SELECTORS))
      .filter(function (n) { return !n.hasAttribute('data-reveal-watched'); });
    if (!nodes.length) return;
    nodes.forEach(function (n) { n.setAttribute('data-reveal-watched', ''); });

    /* PERFORMANCE: measure BEFORE adding .js-reveal.
       .js-reveal sets opacity: 0 on every target — including content that has
       already painted — and the browser dates an element's render from the end
       of the fade back in, so anything above the fold lost seconds of LCP.
       Reading rects first, then marking on-screen nodes `is-visible
       reveal-instant` in the same task, means one style recalc and no
       opacity-0 frame for the first screen. Below-the-fold nodes still hide and
       still animate on scroll. */
    var vh = window.innerHeight || document.documentElement.clientHeight;
    var onScreen = nodes.map(function (n) {
      var r = n.getBoundingClientRect();
      return r.top < vh && r.bottom > 0;
    });

    root.classList.add('js-reveal');
    nodes.forEach(function (n, i) {
      if (!n.hasAttribute('data-reveal')) n.setAttribute('data-reveal', '');
      if (onScreen[i]) n.classList.add('is-visible', 'reveal-instant');
    });

    if (reduce || !('IntersectionObserver' in window)) {
      nodes.forEach(function (n) { n.classList.add('is-visible'); });
      return;
    }

    io = io || new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var el = entry.target;
        // Stagger among reveal siblings sharing a parent (e.g. cards in a grid)
        var idx = 0;
        if (el.parentElement) {
          var sibs = Array.prototype.filter.call(el.parentElement.children, function (c) {
            return c.hasAttribute('data-reveal');
          });
          idx = sibs.indexOf(el);
        }
        el.style.transitionDelay = (Math.min(Math.max(idx, 0), 7) * 65) + 'ms';
        el.classList.add('is-visible');
        io.unobserve(el);
      });
    }, { rootMargin: '0px 0px -6% 0px', threshold: 0.06 });

    nodes.forEach(function (n, i) {
      if (onScreen[i]) return;   // already revealed, nothing to watch
      io.observe(n);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-scan after Section Rendering API refreshes (cart, quick-add, etc.)
  document.addEventListener('shopify:section:load', init);

  /* Markup injected outside the Section Rendering API lifecycle (product
     recommendations, for one) lands after html.js-reveal is already set, so its
     [data-reveal] nodes are painted at opacity 0 with nothing watching them.
     Dispatching `on:reveal:scan` on document hands them to the observer. */
  document.addEventListener('on:reveal:scan', init);
})();
